import React, {useCallback} from "react";
import {CSSObject} from "@core-ui/react-stitch";
import {Transition as ReactTransition} from "react-transition-group";
import {TransitionProps as BaseTransitionProps} from "react-transition-group/Transition";

export type TransitionProps = BaseTransitionProps;

function timeStringToNum(timeString: string): number {
  return parseInt(timeString.split("ms")[0], 10);
}

export function getTransitionDuration({
  transitionDuration,
  transitionDelay = "0ms",
}: CSSObject): number {
  return (
    timeStringToNum(transitionDuration as string) +
    timeStringToNum(transitionDelay as string)
  );
}

export const getTransitionDurations = (
  enterTransition: CSSObject,
  exitTransition: CSSObject
): NonNullable<TransitionProps["timeout"]> => ({
  enter: getTransitionDuration(enterTransition),
  exit: getTransitionDuration(exitTransition),
});

export function Transition({onEnter, ...other}: TransitionProps): JSX.Element {
  const handleOnEnter = useCallback(
    (node: HTMLElement, isAppearing: boolean): void => {
      /* eslint-disable-next-line @typescript-eslint/no-unused-expressions */
      node.offsetHeight;
      onEnter?.(node, isAppearing);
    },
    [onEnter]
  );
  return (
    <ReactTransition
      appear
      mountOnEnter
      onEnter={handleOnEnter}
      unmountOnExit
      {...other}
    />
  );
}
